module.exports = __webpack_public_path__ + "img/pearl.4d2996d7.jpg";